import { useRouteError } from 'react-router-dom';
import PageContent from './PageContent';

function ErrorPage({ selected_node }) {
  const error = useRouteError();

  let title = 'An error occurred!';
  let message = 'Something went wrong!';

  if (error.status === 500) {
    message = error.data.message;
  }

  if (error.status === 404) {
    title = 'Not found!';
    message = 'Could not find resource or page.';
  }

  return (
    <PageContent title={title}>
      <p>{message}</p>
      <p>{selected_node.name}</p>
    </PageContent>
  );
}

export default ErrorPage;
